<template>
  <DepartmentContacts
    :heading="data.heading || ''"
    :phones="data.phones || []"
    :email="data.email || ''"
    :address="data.address || ''"
    :map-image="data.mapImage || ''"
    :map-alt="data.mapAlt || ''"
  />
</template>

<script>
import DepartmentContacts from '@/components/Departments/DepartmentContacts.vue';

export default {
  name: 'AppDepartmentContactsBlock',
  components: { DepartmentContacts },
  props: {
    data: { type: Object, default: () => ({}) },
  },
};
</script>
